export const NOTICE_PERIOD_LIST = [
  {
    value: 1,
    label: "I'm available now",
  },
  {
    value: 2,
    label: '1 week after offer',
  },
  {
    value: 3,
    label: '2 weeks',
  },
  {
    value: 4,
    label: '3 weeks',
  },
  {
    value: 5,
    label: '4 weeks',
  },
  {
    value: 6,
    label: '5 weeks',
  },
  {
    value: 7,
    label: '6 weeks',
  },
  {
    value: 8,
    label: '7 weeks',
  },
  {
    value: 9,
    label: '8 weeks',
  },
  {
    value: 10,
    label: '9+ weeks',
  },
];

export const NOTICE_PERIOD_MAP: Record<number, string> = {
  1: 'Available now',
  2: '1 week after offer',
  3: '2 weeks',
  4: '3 weeks',
  5: '4 weeks',
  6: '5 weeks',
  7: '6 weeks',
  8: '7 weeks',
  9: '8 weeks',
  10: '9+ weeks',
};
